import { helpers } from 'vuelidate/lib/validators';
import { DateTime } from 'luxon';

export default function minDate(value, date) {
  const givenDate = DateTime.fromISO(DateTime.fromISO(value).toISODate());
  const minDate = DateTime.fromISO(DateTime.fromISO(date).toISODate());
  return !helpers.req(value) || givenDate >= minDate;
}
